module.exports = __webpack_public_path__ + "9bce9e825d74d37bb3bb4145ddfb8e53.svg";